import * as VueGoogleMaps from "vue2-google-maps";
import { gmapApi } from "vue2-google-maps";

export default ({ app, Vue }) => {
  Vue.use(VueGoogleMaps, {
    load: {
      key: "AIzaSyBIXnf7dffOe4FneZgPlM6o-FR_2E8FXgg",
      libraries: "places" // This is required if you use the Autocomplete plugin
    }
  });
  Vue.prototype.$google = gmapApi;
};
